import React, { FunctionComponent, useContext, useEffect } from 'react';
import {
  CurrentUserProvider,
  CurrentUserContext,
  CurrentUserContextProps,
} from '/src/contexts/shared/CurrentUserContext';
import { SubscriptionsProvider } from '/src/contexts/SubscriptionsContext';
import {
  SubscriptionsContext,
  SubscriptionsContextProps,
} from '/src/contexts/SubscriptionsContext';
import { PostProvider } from '/src/contexts/PostContext';
import {
  ClubProvider,
  ClubContext,
  ClubContextProps,
} from '/src/contexts/ClubContext';
import { ProfilePrivacyProvider } from '/src/contexts/shared/ProfilePrivacyContext';
import { ThemeProvider, StyledEngineProvider, Box, GlobalStyles } from '@mui/material';
import { ThemeProvider as ThemeProviderForStyles } from '@mui/styles';
import { Header } from '/src/ui/shared/header';
import { Footer } from '/src/ui/shared/footer';
import { CopyRssLinkButton } from './CopyRssLinkButton';
import { AudioPostsLists } from './AudioPostsLists';
import { PostAudioPlayer } from '/src/ui/studentTasks/studentTasks/posts/PostAudioPlayer';

import theme from '/src/ui/shared/styledTheme';
import { theme as themeColor } from '/src/assets/theme';

export const AudiosApp: FunctionComponent = () => {
  return (
    <StyledEngineProvider injectFirst>
      <GlobalStyles
        styles={{
          'body': {
            backgroundColor: themeColor.WHITE_COLOR,
          },
        }}
      />
      <ThemeProvider theme={theme}>
        <ThemeProviderForStyles theme={theme}>
          <CurrentUserProvider defaultUser={null}>
            <SubscriptionsProvider>
              <PostProvider>
                <ClubProvider>
                  <App />
                </ClubProvider>
              </PostProvider>
            </SubscriptionsProvider>
          </CurrentUserProvider>
        </ThemeProviderForStyles>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export enum PageMode {
  USER,
  SEARCH = 'search',
  REPOSTS = 'reposts',
}

const App: FunctionComponent = () => {

  const { currentUser, setCurrentUserState } = useContext(
    CurrentUserContext,
  ) as CurrentUserContextProps;

  const { setListOfSubscriptionsState } = useContext(
    SubscriptionsContext,
  ) as SubscriptionsContextProps;

  const { userClub, requestUserClub, setUserClub } = useContext(ClubContext) as ClubContextProps;

  const fetchInitialData = async () => {
    const currentUser = await setCurrentUserState();
    if (currentUser) {
        setListOfSubscriptionsState(currentUser.id);
        requestUserClub(currentUser.id);
    } else {
        setUserClub(null);
    }
}

  useEffect(() => {
    fetchInitialData();
  }, []);

  return (
    <ProfilePrivacyProvider isReadOnly={false}>
      <Header currentUser={currentUser} />
      <Box
        sx={{
          margin: {
            xs: '1.5rem',
            md: '1.5rem auto',
          },
          maxWidth: {
            md: '1100px',
          },
        }}
      >
        {currentUser && <CopyRssLinkButton isPremiumUser={currentUser.isPremium}/>}
        {userClub !== undefined && <AudioPostsLists userClub={userClub}/>}
      </Box>
      <Footer />
      <PostAudioPlayer />
    </ProfilePrivacyProvider>
  );
};
